<template>
    <div class="btmMsg">
        <div class="info_model">
            <div class="banner" v-if="isBanner">
                <img :src="config.bottom_banner" alt="">
            </div>
            <div class="msg_info">
                <div class="msg">
                    <div class="list contact">
                        <div>
                            <div class="title">联系我们</div>
                            <div class="cont">电话：{{config.phone}}&nbsp;</div>
                            <div class="cont">邮箱：{{config.email}}&nbsp;</div>
                        </div>
                        <div style="margin-left: 160px;">
                            <div class="title">公司地址</div>
                            <div class="cont">{{config.address}}&nbsp;</div>
                            <div class="cont">&nbsp;</div>
                        </div>
                    </div>
                    <div class="line"></div>
                    <div class="list ewm">
                        <div class="qrCode">
                            <img :src="config.wx_offiaccount_url" alt=""/>
<!--                            <div class="jiazhiyuan">嘉志愿公众号</div>-->
                        </div>
                        <div class="qrCode">
                            <img :src="config.wx_mini_url" alt=""/>
<!--                            <div class="jiazhiyuan">嘉志愿小程序</div>-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="forTheRecord" @click="beianhao">
                {{config.copyright}}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{config.icp}}
            </div>
        </div>
    </div>
</template>

<script>


import {getJsonData} from "@/utils/untils";

export default {
    data() {
        return {
            isBanner: true,
            config: {
                address: '',
                banner: '',
                bottom_banner: '',
                copyright: '',
                domain: '',
                email: '',
                hotline_phone: '',
                icp: '',
                logo: '',
                name: '',
                phone: '',
                website_title: '',
                wx_mini_url: '',
                wx_offiaccount_url: '',
            }
        }
    },
    computed: {
        key() {
            let arr = ['/profession', '/subject', '/subject-analyse', '/subject']
            this.isBanner = arr.indexOf(this.$route.path) == -1
            return this.$route.path
        }
    },
    created() {
      this.config = this.getGlobalConfig()
    },
    methods: {
        beianhao() {
            window.open('https://beian.miit.gov.cn/', '_blank')
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@/style/var.scss";


.btmMsg {
    width: 100%;
    margin: 0 auto;
    background-color: #f5f4f8;
    font-family: 'MyCustomFont',sans-serif;
    
    .info_model {
        width: 100%;
        margin: 0 auto;
        
        .msg_info {
            width: 100%;
            margin: 0 auto;
            background: #2C2C2C;
            
            .msg {
                margin: 0 auto;
                width: 1230px;
                height: 224px;
                display: flex;
                font-size: 18px;
                justify-content: space-between;
                padding-top: 40px;
                box-sizing: border-box;
                // align-items: center;
                // color: var(--font-3);
                
                .list {
                    display: flex;
                    // flex-direction: column;
                    
                    .title {
                        // color: var(--font-1);
                        font-weight: 500;
                        margin-bottom: 5px;
                        font-weight: 500;
                        font-size: 14px;
                        color: #FFFFFF;
                    }
                    
                    .cont {
                        margin-top: 15px;
                        cursor: pointer;
                        font-weight: 400;
                        font-size: 14px;
                        color: rgba(255,255,255,0.8);
                    }
                }

                .contact {
                    width: 800px;
                }
                
                .ewm {
                    width: 300px;
                    font-size: 14px;
                    color: var(--font-1);
                    // align-items: center;
                    justify-content: space-between;
                    
                    img {
                        width: 110px;
                        height: 110px;
                        margin-bottom: 15px;
                    }
                    .qrCode{
                        width: 110px;
                    }
                }
            }
        }
        
        .forTheRecord {
            width: 100%;
            text-align: center;
            line-height: 36px;
            height: 36px;
            background: #4D4D4D;
            font-size: 12px;
            color: #ffffff;
            display: flex;
            justify-content: space-around;
        }
        
        .banner {
            width: 1230px;
            margin: 0 auto;
            margin-bottom: 60px;
            
            img {
                width: 1230px;
                height: 240px;
            }
        }
    }
}
.line {
    width: 0px;
    height: 140px;
    border: 1px solid #464646;
}

.jiazhiyuan {
    font-size: 14px;
    color: #ffffff;
    margin: -12px 0 0 12px;
}
</style>
